import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const PortfolioBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Portfolio Website</p>
      <p className="blog-meta">React · Nginx · Self-Hosted</p>

      <div className="blog-body">
        <p>
          Well, you're looking at it.
        </p>
        <p>
          I built this website with React and host it myself on my home server using Nginx as a reverse proxy.
          I wanted my portfolio to be pretty simple and actually feel like something I made instead of
          grabbing a template and changing my name on it.
        </p>

        <h2>The Design</h2>
        <p>
          The black background, pixel font, and minimal colors are all intentional. I know something like
          Press Start 2P isn't exactly the most readable font ever created, but I like how it looks and it's
          my website so I can get away with it.
        </p>
        <p>
          I also tried not to add things just because portfolio websites are "supposed" to have them. There's
          a home page, an about page, my projects, and this blog. That's basically all I need.
        </p>
        <p>
          I don't really like animations just for the sake of having animations or huge sections that don't
          actually say anything. I would rather keep everything simple.
        </p>

        <h2>Self-Hosting It</h2>
        <p>
          The other part of the website is that I'm hosting it myself instead of putting it on something like
          Vercel.
        </p>
        <p>
          Nginx handles the reverse proxy, SSL, and serving the site from my home server. This gives me
          complete control over it, but it also means whenever something stops working I can't blame anyone
          else.
        </p>
        <p>
          Sometimes a service doesn't start correctly or I forget about something and suddenly the website
          doesn't work. Then I SSH into the server and figure out what happened.
        </p>
        <p>
          Honestly that's part of why I like hosting it myself. I know where my website is running, I know
          what's serving it, and if something goes wrong I can actually investigate it myself. The server is
          basically an old repurposed laptop, so it's nothing crazy, but that's more than enough for what I
          use it for.
        </p>

        <h2>What's Next</h2>
        <p>
          This blog is basically the next thing I wanted to add. Project cards are nice for quickly showing
          what I've made, but they don't really give me enough space to explain why I made something or what I
          actually learned from it.
        </p>
        <p>
          Whether I consistently remember to write blog posts is a different question.
        </p>
      </div>
    </div>
  );
};

export default PortfolioBlog;
